import {useCallback, useEffect, useState} from 'react';
import {Box, Stack, Typography} from '@mui/material';
import {useRqProductsLevelsList} from '../../manage-product/ProductQueries';
import {IListAllCompaniesQueryParams} from '../../../../react_query/companies/CompanyWithoutPagination';
import {ICompany} from '../../../../dto/Company.dto';
import InputSearch from '../../../../components/styles/InputSearch';
import ProductsMultipleSelect from '../ProductsMultipleSelect';
import {
  IKeyPartnersProps,
  queryDefault,
  StateMultipleSelect,
  PartnerSwapSelectionCmpt,
  IPartnerProps,
} from '../TnnCampaignCreationStepper';

export const SelectPartners = ({
  title,
  keyType,
  partners,
  setPartners,
}: {
  title: string;
  keyType: IKeyPartnersProps;
  partners: IPartnerProps;
  setPartners: React.Dispatch<React.SetStateAction<IPartnerProps>>;
}) => {
  const [selectedCompanyList, setSelectedCompanyList] = useState<ICompany[]>(
    partners[keyType].selected_companies ?? [],
  );

  const [query, setQuery] = useState<IListAllCompaniesQueryParams>({
    ...queryDefault,
    cmc_product: keyType === 'gametime' ? ['GameTime'] : ['Neptune Radio'],
    module: 'tnn-campaign',
    active: true,
  });

  const {
    data: ProductTypeData,
    isFetching: ProductIsFetching,
    isError: ProductIsError,
  } = useRqProductsLevelsList(true);

  const handleChange = (type: string, selectedIds: string[]) => {
    if (type === 'product') {
      setQuery(prev => {
        return {
          ...prev,
          product_type: selectedIds,
        };
      });
    } else if (type === 'secondary') {
      setQuery(prev => {
        return {
          ...prev,
          secondary_product_type: selectedIds,
        };
      });
    } else if (type === 'dma') {
      setQuery(prev => {
        return {
          ...prev,
          dma: selectedIds,
        };
      });
    } else if (type === 'state') {
      setQuery(prev => {
        return {
          ...prev,
          state: selectedIds,
        };
      });
    }
  };

  const handleSearch = useCallback((newValue: string) => {
    setQuery(prev => ({
      ...prev,
      search: newValue,
    }));
  }, []);

  useEffect(() => {
    setPartners(prev => {
      const prevIds =
        prev[keyType]?.selected_companies?.map(c => c.id).join(',') ?? '';
      const nextIds = selectedCompanyList.map(c => c.id).join(',');
      if (prevIds === nextIds) return prev;
      return {
        ...prev,
        [keyType]: {
          ...prev[keyType],
          selected_companies: selectedCompanyList,
        },
      };
    });
  }, [keyType, setPartners, selectedCompanyList]);

  const titleClassName = `font-bold text-16 ${
    keyType === 'gametime' ? 'mb-2' : ''
  }`;
  return (
    <Box>
      <Typography className={titleClassName}>{title}</Typography>
      {ProductTypeData && !ProductIsFetching && !ProductIsError ? (
        <Stack spacing={1} my={3}>
          <InputSearch
            placeholder='Search'
            value={query.search || ''}
            onChange={handleSearch}
            className='w-300'
          />
          <Stack direction={'row'} spacing={1} alignItems={'center'}>
            <StateMultipleSelect
              className='w-150'
              selecteValues={query.state}
              handleChange={handleChange}
            />
            <ProductsMultipleSelect
              className='w-150'
              label='DMA'
              type='dma'
              data={ProductTypeData?.dma}
              handleChange={handleChange}
              selecteValues={query.dma}
            />
            <ProductsMultipleSelect
              className='w-150'
              label='Primary Type'
              type='product'
              data={ProductTypeData?.primary}
              handleChange={handleChange}
              selecteValues={query.product_type}
            />
            <ProductsMultipleSelect
              className='w-150'
              label='Secondary Type'
              type='secondary'
              data={ProductTypeData?.secondary}
              handleChange={handleChange}
              selecteValues={query.secondary_product_type}
            />
          </Stack>
        </Stack>
      ) : null}
      <PartnerSwapSelectionCmpt
        query={query}
        selectedCompanyList={selectedCompanyList}
        setSelectedCompanyList={setSelectedCompanyList}
      />
    </Box>
  );
};
